import gql from 'graphql-tag';

export default gql`
  mutation updateRsvpRepVisit($input: updateRsvpRepVisitInput!) {
    updateRsvpRepVisit(input: $input) {
      repVisit {
        id
        appointments {
          id
          status
          notes
          bookedByUser
          bookedByCollege
          currentColleges
          userBookingStatus
          visitUrl
        }
        status
        currentColleges
      }
    }
  }
`;
